import ShModel from 'sh-www/models/sh-model';
import { ASSIGNMENT } from 'sh-www/models/assignment';
import { attr, belongsTo, hasMany } from '@ember-data/model';

class ApplicationDetail extends ShModel {
  @attr('number') compensationMax;
  @attr('number') compensationMin;
  @attr('string') description;
  @attr('string') descriptionLinkified;
  @attr('number') estimatedDays;
  @attr('string') examples;
  @attr('string') examplesLinkified;
  @attr('number') rateType;
  @attr('string') title;

  @belongsTo('application', { async: false }) application;
  @hasMany('application-deliverable', { async: false }) applicationDeliverables;
  @hasMany('application-schedule', { async: false }) applicationSchedules;
  @belongsTo('location', { async: false }) candidateLocation;
  @belongsTo('location', { async: false }) location;
  @hasMany('service', { async: false }) services;

  /** @type {string} */
  get locationText() {
    return this.location?.formattedAddress ?? 'Global';
  }

  /** @type {Array<ApplicationSchedule>} */
  get scheduleItems() {
    return this.applicationSchedules.sortBy('date');
  }

  /**
   * Total compensation range for the application taking into account the rateType
   *
   * @type {String}
   */
  get totalCompensationRange() {
    const estimatedDays = this.rateType === ASSIGNMENT.RATE_TYPE.FLAT ? 1 : this.estimatedDays;

    const totalCompensationMin = this.compensationMin * estimatedDays;
    const totalCompensationMax = this.compensationMax * estimatedDays;
    if (totalCompensationMin === totalCompensationMax) return `$${totalCompensationMin}`;
    return `$${totalCompensationMin} - $${totalCompensationMax}`;
  }
}

export default ApplicationDetail;
